(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["back-to-top"] && !Shopify.designMode) return;
  try {
    (function () {
    var btn = document.querySelector('[data-back-to-top]');
    if (!btn || btn.dataset.boundBackToTop) return;
    btn.dataset.boundBackToTop = '1';
    btn.hidden = false;

    var THRESHOLD = 400;
    var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function updateVisibility() {
      var scrolled = window.scrollY || document.documentElement.scrollTop;
      btn.classList.toggle('is-visible', scrolled > THRESHOLD);
    }

    btn.addEventListener('click', function () {
      window.scrollTo({
        top: 0,
        behavior: prefersReduced ? 'auto' : 'smooth',
      });
    });

    var ticking = false;
    window.addEventListener(
      'scroll',
      function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          updateVisibility();
          ticking = false;
        });
      },
      { passive: true }
    );

    updateVisibility();
  })();
  } catch(e) { console.error(e); }
})();

})();
